import { WordPress } from "../../../../wordpress/wordpress_api";
import { CMSState, Link as LinkType } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { IOWidget, Action, mk_widget } from "widgets-for-react";
import { PublicSiteState } from "../../../../public_site.main.mod";
import React from "react";
import { link, linkWrapper, isLinkExternal, isLinkDownload } from "../../../../cms/blocks/utils.gen";
import { toRelativeUrl } from "../../../../../helpers";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";
import { Link } from "react-router-dom";

export type GridBlockItem = {
    title: string
    intro: string
    image?: WordPress.MediaResponse
    link?: LinkType
}

export type GridAttributes = {
    blockName: 'vidda/grid'
    title: string
    intro: string
    primary_button?: ButtonData
    secondary_button?: ButtonData
    blocks: Array<GridBlockItem>
}

export interface GridInterface {
    blockName: 'vidda/grid'
    attrs: GridAttributes
}

export type GridBlockProps<extra_images> = GridAttributes

export type GridBlockStyle = Partial<{
    block_classname: string
    inner_classname: string
    header_classname: string
    title_classname: string
    content_classname: string
    intro_classname: string
    visual_classname: string
}>

export function GridBlock<customBlockData, extra_images>(
    props: GridBlockProps<extra_images>,
    options?: { style: GridBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
        return mk_widget({
            run: _ => (
              <section className="block block--grid block--background">
                <div className="block__inner container--xl grid--block">
                  <header className="block__header">
                    {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
                    {props.intro && (<p className="block__intro" dangerouslySetInnerHTML={{ __html: props.intro }}></p>)}
                  </header>
                   
                      <div className="block__content">
                        <ul className="block__grid grid">
                        {props.blocks.filter(grid => grid != undefined).map(grid => {
                          const gridItemInner: JSX.Element = <>
                            <div className="grid__content">
                              {grid.title && <h3 className="grid__title typo--l">{grid.title}</h3>}
                              {grid.intro && <p className="grid__intro typo--2xs">{grid.intro}</p>}
                              {grid.link && <span className="grid__fauxlink">{grid.link.title}</span>}
                            </div>
                            {grid.image && 
                              <div className="grid__visual fit-object">
                                <img
                                  src={getImageAttribute(grid.image, 'grid', 'source_url')}
                                  width={getImageAttribute(grid.image, 'grid', 'width')}
                                  height={getImageAttribute(grid.image, 'grid', 'height')}
                                  alt={grid.image.alt_text ? grid.image.alt_text : ''}
                                />
                              </div>
                            }
                          </>

                          return <li className="grid__item">
                            {grid.link ? 
                              grid.link.is_link_external || isLinkDownload(grid.link.url) ? 
                                <a className="grid__link" href={grid.link.url} target={'_blank'}>
                                  { gridItemInner }
                                </a>
                              : <Link className="grid__link" to={grid.link.url}>
                                  { gridItemInner }
                                </Link>
                              :
                                <div className="grid__inner">{ gridItemInner }</div>
                            }
                          </li>
                        })}
                        </ul>
                        
                      </div>
                    {(props.primary_button || props.secondary_button) && (
                      <footer className="block__footer">
                      {props.primary_button && (
                        link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                        { classname: 'button button--primary' },
                        props.primary_button.text
                        )
                      )}
                      {props.secondary_button && (
                        link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                        { classname: 'button button--secondary' },
                        props.secondary_button.text
                        )
                      )}
                      </footer>
                    )}
                  </div>
              </section>
            )
        })
    }
}